// removed by extract-text-webpack-plugin
module.exports = {"fund-details-table-switch-wrap":"fund-details-table-switch-wrap___10K7p","fund-details-table-switch":"fund-details-table-switch___2Juc7 h2___hzLuT","dtls-tbl-row":"dtls-tbl-row___2UE2k h3___5u0xZ","dtls-tbl-lbl":"dtls-tbl-lbl___27zTr","dtls-tbl-val":"dtls-tbl-val___164BK","r":"r___29-pU","c":"c___2mVmM","cr":"cr___3Bsqm center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardFundDetails/PlanScorecardFundDetails.css
// module id = 899
// module chunks = 0